import { Component, Inject } from '@angular/core';
import { TA_MODAL_DATA } from "teccom-web-components";
import { TscDialogModel } from "../tsc-dialog/models/tsc-dialog.model";

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent {
  constructor(@Inject(TA_MODAL_DATA) public data: TscDialogModel) {
  }
}
